import type {z} from "zod";

import {CreateMaterialBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {materialFieldLabelIds} from "../../../messages/materials.messages";

const [simple, composite] = CreateMaterialBody.options;
const fields = {
  code: requiredStringSchema(simple.shape.code, materialFieldLabelIds.code),
  name: requiredStringSchema(simple.shape.name, materialFieldLabelIds.name),
  internalDescription: requiredStringSchema(
    simple.shape.internalDescription,
    materialFieldLabelIds.internalDescription,
  ),
  priceProtected: simple.shape.priceProtected,
  unitOfMeasure: simple.shape.unitOfMeasure,
};
const simpleFields = zod.object({
  ...fields,
  compositionKind: simple.shape.compositionKind,
  initialSupplierId: requiredStringSchema(
    simple.shape.initialSupplierId,
    materialFieldLabelIds.initialSupplierId,
  ),
});
const compositeFields = zod.object({
  ...fields,
  compositionKind: composite.shape.compositionKind,
  components: composite.shape.components,
});

export const createMaterialFormSchema = zod.union([simpleFields, compositeFields]);
export type CreateMaterialFormPayload = z.output<typeof createMaterialFormSchema>;

export const draftCreateMaterialFormSchema = zod
  .object({
    ...fields,
    compositionKind: zod.union([simple.shape.compositionKind, composite.shape.compositionKind]),
    initialSupplierId: simple.shape.initialSupplierId,
    components: composite.shape.components,
  })
  .partial();
export type DraftCreateMaterialFormPayload = z.output<typeof draftCreateMaterialFormSchema>;
